import { RESET_STATE } from 'store/global/actions';

import { ANALYTICS_ACTION_TYPE } from '../actions';

const initialQueryState = { data: [], isLoading: false, hasError: false };

const initialState = {
  attribution: initialQueryState,
  leakage: initialQueryState,
  replayResult: null,
  sampleAttribution: { data: null, isLoading: false, hasError: false },
};

const analyticsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ANALYTICS_ACTION_TYPE.SET_ATTRIBUTION_LOADING:
      return {
        ...state,
        attribution: {
          ...state.attribution,
          isLoading: payload,
          hasError: payload ? false : state.attribution.hasError,
        },
      };

    case ANALYTICS_ACTION_TYPE.SET_ATTRIBUTION_ERROR:
      return { ...state, attribution: { ...state.attribution, isLoading: false, hasError: true } };

    case ANALYTICS_ACTION_TYPE.GET_MARGIN_ATTRIBUTION:
      return { ...state, attribution: { data: payload ?? [], isLoading: false, hasError: false } };

    case ANALYTICS_ACTION_TYPE.SET_LEAKAGE_LOADING:
      return {
        ...state,
        leakage: {
          ...state.leakage,
          isLoading: payload,
          hasError: payload ? false : state.leakage.hasError,
        },
      };

    case ANALYTICS_ACTION_TYPE.SET_LEAKAGE_ERROR:
      return { ...state, leakage: { ...state.leakage, isLoading: false, hasError: true } };

    case ANALYTICS_ACTION_TYPE.GET_LEAKAGE_BY_CAUSE:
      return { ...state, leakage: { data: payload ?? [], isLoading: false, hasError: false } };

    case ANALYTICS_ACTION_TYPE.REPLAY_PRICING:
      return { ...state, replayResult: payload ?? null };

    case ANALYTICS_ACTION_TYPE.SET_SAMPLE_ATTRIBUTION_LOADING:
      return {
        ...state,
        sampleAttribution: {
          ...state.sampleAttribution,
          isLoading: payload,
          hasError: payload ? false : state.sampleAttribution.hasError,
        },
      };

    case ANALYTICS_ACTION_TYPE.SET_SAMPLE_ATTRIBUTION_ERROR:
      return {
        ...state,
        sampleAttribution: { ...state.sampleAttribution, isLoading: false, hasError: true },
      };

    case ANALYTICS_ACTION_TYPE.GET_SAMPLE_ATTRIBUTION:
      return {
        ...state,
        sampleAttribution: { data: payload ?? null, isLoading: false, hasError: false },
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default analyticsReducer;
